import { useIntl } from "react-intl";

const TemplateLibrary = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.templateLibrary.header",
            defaultMessage: "Template library"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.templateLibrary.content",
            defaultMessage:
                "Use the template library for everything from product requirement documents to marketing plans. Or, create your own custom template."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.templateLibrary.altText",
            defaultMessage: "Examples of templates"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.templateLibrary.caption",
            defaultMessage:
                "Here are a few templates from the Confluence library."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/template_library-2X.webp"
                alt={messages.altText}
                height={215}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default TemplateLibrary;
